<template lang="pug">
div.store-settings-page.vitrify-content.expande-horizontal.column(:class="{ 'pt-3': $vuetify.breakpoint.smAndUp, 'store-settings-dark': isDark }")
  div.company-summary
    v-avatar.company-avatar(size="84")
      v-img(:src="companyProfileImage")
    h2.fonte.mb-0 {{ companyName }}
    span.fonte.fonteMini.grey--text {{ companyDocument }}
    span.fonte.fonteMini.grey--text(v-if="companyPhone") {{ companyPhone }}
    v-btn.subscription-settings-btn(
      v-if="getLoggedUser && getLoggedUser.admin"
      small
      rounded
      depressed
      dark
      color="#075e54"
      @click="openSubscriptionModal"
    )
      v-icon(left small) mdi-crown-outline
      | Ver assinatura
  div.settings-panel
    v-tabs.settings-tabs(
      centered
      show-arrows
      :color="$theme.primary"
      v-model="activeTab"
    )
      v-tab
        v-icon.mr-2(size="18") mdi-cash-sync
        | Formas de Pagamento
      v-tab
        v-icon.mr-2(size="18") mdi-percent-outline
        | Impostos
      v-tab
        v-icon.mr-2(size="18") mdi-printer-pos-edit
        | Textos do Orçamento
      v-tab
        v-icon.mr-2(size="18") mdi-storefront
        | Informações da Empresa
      v-tab
        v-icon.mr-2(size="18") mdi-message-text-clock-outline
        | Templates IntraWhats
    v-divider
    v-tabs-items(v-model="activeTab")
      v-tab-item
        div.tab-content
          taxConfig(:payment_sys_config="payment_sys_config" :payment_menurocket_config="payment_menurocket_config")
      v-tab-item
        div.tab-content
          reportTaxesConfig(:report_taxes="report_taxes")
      v-tab-item
        div.tab-content
          receiptConfig(:view="showView", :receipt="receipt")
      v-tab-item
        div.tab-content
          storeConfig
      v-tab-item
        div.tab-content
          whatsappTemplates(
            :whatsapp_flow_templates="whatsapp_flow_templates"
            :saving="saving_whatsapp_templates"
            @save="$emit('save-whatsapp-templates', $event)"
          )
  ModalSubscription(ref="modalSubscription")
  //- deliveryConfig(:view="showView")
</template>

<script>
import localConfig from "../Desktop/Local/Index.vue";
import tableConfig from "../Desktop/Table/Index.vue";
import receiptConfig from "../Desktop/Receipt/Index.vue";
import taxConfig from "../Desktop/Tax/Index.vue";
import reportTaxesConfig from "../Desktop/ReportTaxes/Index.vue";
import deliveryConfig from "../Desktop/Delivery/Index.vue";
import storeConfig from "../Desktop/Store/Index.vue";
import whatsappTemplates from "../Desktop/WhatsappTemplates/Index.vue";
import ModalSubscription from "@/apps/dashboard/components/ModalSubscription.vue";
import { EventBus } from "@/main.js";
import { mapGetters } from "vuex";
export default {
  props: [
    "local",
    "payment_sys_config",
    "payment_menurocket_config",
    "receipt",
    "report_taxes",
    "whatsapp_flow_templates",
    "saving_whatsapp_templates"
  ],
  data() {
    return {
      showView: "",
      activeTab: 0
    };
  },
  components: {
    localConfig,
    tableConfig,
    receiptConfig,
    taxConfig,
    reportTaxesConfig,
    deliveryConfig,
    storeConfig,
    whatsappTemplates,
    ModalSubscription
  },
  computed: {
    ...mapGetters(["getLoggedUser"]),
    company() {
      const tenants = this.getLoggedUser && this.getLoggedUser.tenant
        ? this.getLoggedUser.tenant
        : [];
      return tenants[0] || this.getLoggedUser.activeTenant || {};
    },
    companyName() {
      return this.company.nome || "Minha empresa";
    },
    companyDocument() {
      return this.company.cnpj ? `CNPJ: ${this.company.cnpj}` : "Documento não informado";
    },
    companyPhone() {
      return this.company.phone || "";
    },
    companyProfileImage() {
      return this.company.profileImage || "https://via.placeholder.com/512x512";
    },
    isDark() {
      return localStorage.dark === "true";
    }
  },
  watch: {
    "$route.query.tab"() {
      this.setActiveTabFromRoute();
    }
  },
  methods: {
    openSubscriptionModal() {
      if (this.$refs.modalSubscription) {
        this.$refs.modalSubscription.open();
      }
    },
    setActiveTabFromRoute() {
      const tabs = { payments: 0, taxes: 1, impostos: 1, receipt: 2, company: 3, whatsapp: 4, intrawhats: 4 };
      const tab = this.$route.query.tab;
      if (Object.prototype.hasOwnProperty.call(tabs, tab)) {
        this.activeTab = tabs[tab];
      }
    }
  },
  created() {
    this.setActiveTabFromRoute();
    const self = this;
    EventBus.$on("set-config-view", view => {
      self.showView = view;
      self.$forceUpdate();
    });
  }
};
</script>

<style scoped>
.store-settings-page {
  box-sizing: border-box;
  max-height: none;
  min-height: calc(100vh - 72px);
  overflow: auto;
  padding: 18px 22px 28px;
  width: 100%;
}
.store-settings-dark {
  background: #0b141a;
  color: #e9edef;
}
::v-deep .store-settings-dark,
::v-deep .store-settings-dark .layout,
::v-deep .store-settings-dark .container,
::v-deep .store-settings-dark .v-main,
::v-deep .store-settings-dark .v-main__wrap,
::v-deep .store-settings-dark .v-application--wrap {
  background: #0b141a !important;
}
.company-summary {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 2px auto 20px;
  max-width: 1180px;
  text-align: center;
  width: 100%;
}
.company-avatar {
  background: #f2f2f2;
  border: 4px solid rgba(255, 255, 255, 0.82);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
  margin-bottom: 6px;
}
.subscription-settings-btn {
  box-shadow: 0 8px 22px rgba(7, 94, 84, 0.18) !important;
  margin-top: 8px;
  text-transform: none;
}
.store-settings-dark .company-avatar {
  background: #202c33;
  border-color: #26343c;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.38);
}
.store-settings-dark .company-summary ::v-deep .grey--text,
.store-settings-dark .company-summary .grey--text {
  color: #aebac1 !important;
}
.settings-panel {
  background: transparent;
  margin: 0 auto;
  max-width: 1180px;
  width: 100%;
}
.settings-tabs {
  background: transparent;
  border-bottom: 0;
  margin: 0 auto;
  max-width: 840px;
  padding: 4px;
}
.settings-tabs ::v-deep .v-tabs-bar,
.settings-tabs ::v-deep .v-slide-group__wrapper,
.settings-tabs ::v-deep .v-slide-group__content {
  background: transparent !important;
}
.settings-tabs ::v-deep .v-tab {
  border-radius: 999px;
  letter-spacing: 0;
  margin: 0 4px 8px;
  min-height: 42px;
  text-transform: none;
  transition: 0.18s ease;
}
.settings-tabs ::v-deep .v-tab--active {
  background: rgba(18, 140, 126, 0.12);
}
.store-settings-page:not(.store-settings-dark) ::v-deep .v-tabs-items,
.store-settings-page:not(.store-settings-dark) ::v-deep .v-window,
.store-settings-page:not(.store-settings-dark) ::v-deep .v-window__container,
.store-settings-page:not(.store-settings-dark) ::v-deep .v-window-item,
.store-settings-page:not(.store-settings-dark) ::v-deep .tab-content {
  background: transparent !important;
  background-color: transparent !important;
}
.store-settings-dark .settings-tabs {
  background: transparent;
}
.store-settings-dark .settings-tabs ::v-deep .v-tab {
  background: #111b21;
  border: 1px solid #26343c;
  color: #aebac1 !important;
}
.store-settings-dark .settings-tabs ::v-deep .v-tab--active {
  background: #005c4b;
  border-color: #128C7E;
  color: #e9edef !important;
}
.store-settings-dark .settings-tabs ::v-deep .v-tab .v-icon {
  color: inherit !important;
}
.store-settings-dark ::v-deep .v-tabs-items,
.store-settings-dark ::v-deep .v-window,
.store-settings-dark ::v-deep .v-window-item,
.store-settings-dark ::v-deep .tab-content {
  background: #0b141a !important;
  color: #e9edef !important;
}
.store-settings-dark ::v-deep .v-card,
.store-settings-dark ::v-deep .v-list,
.store-settings-dark ::v-deep [style*="background: #f2f2f2"],
.store-settings-dark ::v-deep [style*="background: #e0e0e0"],
.store-settings-dark ::v-deep [style*="background: #fff"],
.store-settings-dark ::v-deep [style*="background: #ffffff"] {
  background: transparent !important;
  background-color: transparent !important;
  color: #e9edef !important;
}
.store-settings-dark ::v-deep .v-list-item__title,
.store-settings-dark ::v-deep .v-list-item__subtitle,
.store-settings-dark ::v-deep .fonte,
.store-settings-dark ::v-deep span,
.store-settings-dark ::v-deep h1,
.store-settings-dark ::v-deep h2,
.store-settings-dark ::v-deep h3,
.store-settings-dark ::v-deep [style*="color: #333"],
.store-settings-dark ::v-deep [style*="color:#333"],
.store-settings-dark ::v-deep [style*="color: #363636"],
.store-settings-dark ::v-deep [style*="color:#363636"] {
  color: #e9edef !important;
}
.store-settings-dark ::v-deep .grey--text {
  color: #aebac1 !important;
}
.store-settings-dark ::v-deep .black--text {
  color: #e9edef !important;
}
.store-settings-dark ::v-deep .v-input__slot,
.store-settings-dark ::v-deep textarea,
.store-settings-dark ::v-deep input {
  background: #202c33 !important;
  color: #e9edef !important;
}
.store-settings-dark ::v-deep .v-label,
.store-settings-dark ::v-deep .v-select__selection,
.store-settings-dark ::v-deep input::placeholder,
.store-settings-dark ::v-deep textarea::placeholder {
  color: #aebac1 !important;
}
.store-settings-dark ::v-deep .v-divider {
  border-color: #26343c !important;
}
.store-settings-dark ::v-deep .v-icon {
  color: #aebac1 !important;
}
.store-settings-dark ::v-deep .v-avatar .v-icon {
  color: #111b21 !important;
}
.tab-content {
  max-height: calc(95vh - 230px);
  overflow: auto;
  padding: 20px 0 0;
}
::v-deep .tab-content .v-card {
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  min-height: auto !important;
}
::v-deep .tab-content .v-list {
  background: transparent !important;
}
::v-deep .tab-content > .flex,
::v-deep .tab-content > .flex > .flex {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
::v-deep .tab-content .store-layout {
  min-height: 120px;
}
@media(max-width: 900px) {
  .store-settings-page {
    max-height: none;
    padding: 10px;
  }
  .tab-content {
    max-height: none;
    padding: 10px;
  }
}
</style>
